
import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { isBrowser } from "@/utils/runtime";

const TocTocHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!isBrowser) return;
    const handleScroll = () => {
      if (globalThis.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    globalThis.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => globalThis.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <header className={`py-4 bg-white sticky top-0 z-50 transition-all duration-300 ${isScrolled ? "shadow-md py-2" : "shadow-sm"}`}>
      <div className="container max-w-7xl mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/lovable-uploads/24e0e29e-3e10-43db-8be9-1cc4bc18ab2f.png"
              alt="TocToc Fotografia Imobiliária - Logo"
              loading="eager"
              width="114"
              height="64"
              className="h-16"
              decoding="async"
            />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8 items-center">
          <Link to="/" className={`font-medium transition-colors ${isActive('/') ? "text-[#FF5605] border-b-2 border-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}>
            Início
          </Link>
          <Link to="/servicos" className={`font-medium transition-colors ${isActive('/servicos') ? "text-[#FF5605] border-b-2 border-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}>
            Serviços
          </Link>
          <Link to="/portfolio" className={`font-medium transition-colors ${isActive('/portfolio') ? "text-[#FF5605] border-b-2 border-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}>
            Portfólio
          </Link>
          <Link to="/sobre" className={`font-medium transition-colors ${isActive('/sobre') ? "text-[#FF5605] border-b-2 border-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}>
            Sobre Nós
          </Link>
          
          <Link to="/contato">
            <Button className="bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full">
              Solicite Orçamento
            </Button>
          </Link>
        </nav>

        {/* Mobile Navigation */}
        <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
          <SheetTrigger asChild>
            <Button variant="ghost" className="md:hidden">
              <Menu className="h-6 w-6" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="bg-white border-l border-gray-200">
            <div className="flex flex-col gap-4 mt-8">
              <Link 
                to="/" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Início
              </Link>
              <Link 
                to="/servicos" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/servicos') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Serviços
              </Link>
              <Link 
                to="/portfolio" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/portfolio') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Portfólio
              </Link>
              <Link 
                to="/sobre" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/sobre') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Sobre Nós
              </Link>
              <Link 
                to="/blog" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/blog') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link 
                to="/faq" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/faq') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                FAQ
              </Link>
              <Link 
                to="/centraldeajuda" 
                className={`text-lg font-medium transition-colors text-left ${isActive('/centraldeajuda') ? "text-[#FF5605]" : "text-[#323031] hover:text-[#FF5605]"}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Central de Ajuda
              </Link>
              <Link to="/contato" className="mt-4" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-[#FF5605] hover:bg-[#E14D04] text-white rounded-full">
                  Solicite Orçamento
                </Button>
              </Link>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};

export default TocTocHeader;
